import { render, staticRenderFns } from "./LunBoTu.vue?vue&type=template&id=0d5967ac&scoped=true&"
import script from "./LunBoTu.vue?vue&type=script&lang=js&"
export * from "./LunBoTu.vue?vue&type=script&lang=js&"
import style0 from "./LunBoTu.vue?vue&type=style&index=0&id=0d5967ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5967ac",
  null
  
)

export default component.exports